import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  template: `<div
    class="flex items-center justify-center rounded-full bg-cover bg-center"
    [ngClass]="{
      'h-10 w-10': size === 'sm',
      'h-20 w-20': size === 'lg',
      'bg-primary-100': !avatarImage && randomIndex === 0,
      'bg-info-50': !avatarImage && randomIndex === 1,
      'bg-neutral-100': !avatarImage && randomIndex === 2,
      'bg-warning-50': !avatarImage && randomIndex === 3
    }"
    [style.background-image]="avatarImage">
    <label
      *ngIf="!avatarImage"
      class="prose font-semibold "
      [ngClass]="{
        'prose-text-sm': size === 'sm',
        'prose-display-md': size === 'lg',
        'text-primary-900': randomIndex === 0,
        'text-info-500': randomIndex === 1,
        'text-neutral-600': randomIndex === 2,
        'text-warning-500': randomIndex === 3
      }"
      >{{ avatarName }}</label
    >
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent {
  avatarImage?: string;
  avatarName?: string;
  protected readonly randomIndex = Math.floor(Math.random() * 4);

  @Input() size: 'sm' | 'lg' = 'sm';
  @Input() set src(value: string | undefined) {
    this.avatarImage = value ? `url(${value})` : undefined;
  }
  @Input() set name(value: string | undefined) {
    if (!value) this.avatarName = undefined;
    else if (!value.includes(' ')) this.avatarName = value.substring(0, 2);
    else
      this.avatarName = value
        .split(' ')
        .map(x => x[0])
        .slice(0, 4)
        .join('');
  }
}
